import { useState } from 'react';
import InputRange from '../../Atoms/InputRange';
import Text from '../../Atoms/Text';

function RangeDistance() {
  const DEFAULT_VALUE = 80;
  const [amount, setAmount] = useState(DEFAULT_VALUE);

  return (
    <div className="flex flex-col gap-y-3">
      <InputRange
        max={150}
        min={0}
        step={5}
        defaultValue={DEFAULT_VALUE}
        passValue={(val) => setAmount(val)}
      />
      <Text
        color="indigo"
        font="circular"
        size="sm"
        weight={500}
      >
        <span>
          Max <output>{amount}</output> kilometer
        </span>
      </Text>
    </div>
  );
}

export default RangeDistance;
